import React, { useContext } from 'react';

import { MobileMenuContext } from '../contexts/MobileMenuContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBurger } from '@fortawesome/free-solid-svg-icons';

const ShowMainNavMobile = () => {
    const[, setMobileMenuContext] = useContext(MobileMenuContext);

    const handleShowMenu = () => {
        setMobileMenuContext({
            type: 'SHOW_MENU'
        });
    }
    return(
        <div id="show-mobile-nav">
            <span>Menu :</span>
            <button className="btn" onClick={handleShowMenu}>
                <FontAwesomeIcon icon={faBurger} />
            </button>
        </div>
    );
};

export default ShowMainNavMobile;